import { render } from "./ServicesDetailsPage.vue?vue&type=template&id=c3b5c0bc&ts=true"
import script from "./ServicesDetailsPage.vue?vue&type=script&lang=ts"
export * from "./ServicesDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__